import invertorImage from './divine construction/invertor.jpg'; // {{ edit_1 }}
import indoorlightingImage from './divine construction/indoorli.jpg'; // {{ edit_2 }}
import product3Image from './divine construction/pole.jpg'; // {{ edit_3 }}
import product4Image from './divine construction/solar.jpg'; 
import product6Image from './divine construction/solar2.jpg'; // {{ edit_4 }}
import product5Image from './divine construction/transformer.jpg'; // {{ edit_5 }}

const dummyProducts = [
    {
      id: 1,
      name: 'Invertor Fix and Supply',
      price: '1000',
      description: 'We supply and fix all types of invertors',
      image: invertorImage, // {{ edit_6 }}
    },
    {
      id: 2,
      name: 'Tubing',
      price: '1000',
      description: 'We supply all types of tubing',
      image: indoorlightingImage, // {{ edit_7 }}
    },
    {
      id: 3,
      name: 'Out Door Electricity Fixing',
      price: '1000',
      description: 'We fix all types of out door electricity',
      image: product3Image, // {{ edit_8 }}
    },
    {
      id: 4,
      name: 'Solar Panel Fixing',
      price: '1000',
      description: 'We fix all types of solar panels',
      image: product4Image, // {{ edit_9 }}
    },
    {
      id: 5,
      name: 'Transformer Fixing',
      price: '1000',
      description: 'We fix all types of transformers',
      image: product5Image, // {{ edit_10 }}
    },
    {
        id: 6,
        name: 'Transformer Fixing',
        price: '1000',
        description: 'We supply all types of solar panels',
        image: product6Image, // {{ edit_10 }}
      },
  ];
  
  export default dummyProducts; // {{ edit_11 }}